import _asyncToGenerator from "/vercel/path1/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
import React from "react";
var __jsx = React.createElement;
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
import classNames from "classnames";
import { useRef, useState } from "react";
import { useTranslation } from "react-i18next";
// @ts-ignore
import ReactCrop from "react-image-crop";
import { isWebView } from "../../../utils";
import Button from "../../common/Button";
var CropImage = function CropImage(props) {
  var imageSrc = props.imageSrc,
    onConfirmedUpload = props.onConfirmedUpload,
    isUploadComplete = props.isUploadComplete,
    onMainUploadScreen = props.onMainUploadScreen,
    currentFile = props.currentFile,
    hasCurrentPatient = props.hasCurrentPatient;
  var initialCropState = {
    unit: "%",
    width: 60,
    height: 50,
    x: 20,
    y: 15
  };
  var _useState = useState(true),
    isCropperOpen = _useState[0],
    toggleCropper = _useState[1];
  var _useState2 = useState(initialCropState),
    crop = _useState2[0],
    setCrop = _useState2[1];
  var _useState3 = useState(initialCropState),
    completedCrop = _useState3[0],
    setCompletedCrop = _useState3[1];
  var _useState4 = useState(""),
    croppedImageUrl = _useState4[0],
    setCroppedImageUrl = _useState4[1];
  var _useState5 = useState(null),
    croppedImageFile = _useState5[0],
    setCroppedImageFile = _useState5[1];
  var imageRef = useRef(null);
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var getCroppedImg = function getCroppedImg(image, crop, currentFile) {
    var canvas = document.createElement("canvas");
    var ctx = canvas.getContext("2d");
    if (!ctx || !image) {
      throw new Error("Failed to get canvas context.");
    }
    var scaleX = image.naturalWidth / image.width;
    var scaleY = image.naturalHeight / image.height;
    canvas.width = crop.width;
    canvas.height = crop.height;
    ctx.drawImage(image, crop.x * scaleX, crop.y * scaleY, crop.width * scaleX, crop.height * scaleY, 0, 0, crop.width, crop.height);
    return new Promise(function (resolve, reject) {
      canvas.toBlob(function (blob) {
        if (!blob) {
          reject(new Error("Canvas is empty."));
          return;
        }
        var array = [blob];
        var options = {
          type: (currentFile === null || currentFile === void 0 ? void 0 : currentFile.type) || "image/jpeg"
        };
        try {
          var file = new File(array, (currentFile === null || currentFile === void 0 ? void 0 : currentFile.name) || "cropped-image.jpg", options);
          window.URL.revokeObjectURL(croppedImageUrl);
          var url = window.URL.createObjectURL(blob);
          resolve({
            file: file,
            url: url
          });
        } catch (error) {
          reject(error);
        }
      }, "image/jpeg");
    });
  };
  var onClickCrop = function onClickCrop() {
    toggleCropper(!isCropperOpen);
  };
  var onFinishCropping = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
      return _regenerator().w(function (_context) {
        while (1) switch (_context.n) {
          case 0:
            onConfirmedUpload(croppedImageFile);
          case 1:
            return _context.a(2);
        }
      }, _callee);
    }));
    return function onFinishCropping() {
      return _ref.apply(this, arguments);
    };
  }();
  var onAfterCropping = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
      var croppedImage;
      return _regenerator().w(function (_context2) {
        while (1) switch (_context2.n) {
          case 0:
            _context2.n = 1;
            return getCroppedImg(imageRef === null || imageRef === void 0 ? void 0 : imageRef.current, completedCrop, currentFile);
          case 1:
            croppedImage = _context2.v;
            onClickCrop();
            setCroppedImageUrl(croppedImage === null || croppedImage === void 0 ? void 0 : croppedImage.url);
            setCroppedImageFile(croppedImage === null || croppedImage === void 0 ? void 0 : croppedImage.file);
          case 2:
            return _context2.a(2);
        }
      }, _callee2);
    }));
    return function onAfterCropping() {
      return _ref2.apply(this, arguments);
    };
  }();
  var onImageLoaded = function onImageLoaded(image) {
    imageRef.current = image;
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, !croppedImageUrl ? /*#__PURE__*/React.createElement("div", {
    className: "pb-4 mx-auto w-full flex-1 flex flex-col overflow-hidden"
  }, !hasCurrentPatient && /*#__PURE__*/React.createElement("p", {
    className: "text-xl px-6 text-left pb-2"
  }, t("capture_scan")), /*#__PURE__*/React.createElement("div", {
    className: "flex-1 px-6 flex flex-col justify-center items-center overflow-hidden"
  }, /*#__PURE__*/React.createElement("div", {
    className: "relative !max-h-[500px] overflow-y-auto scrollbar-light dark:scrollbar rounded-lg"
  }, /*#__PURE__*/React.createElement(ReactCrop, {
    src: imageSrc,
    onImageLoaded: onImageLoaded,
    crop: crop,
    keepSelection: true,
    ruleOfThirds: true,
    onChange: function onChange(c) {
      return setCrop(c);
    },
    onComplete: function onComplete(c) {
      return setCompletedCrop(c);
    }
  })), /*#__PURE__*/React.createElement("p", {
    className: "text-gray-100 p-2 text-base text-center"
  }, "*", t("Drag & resize the dotted lines to crop image."))), /*#__PURE__*/React.createElement("div", {
    className: classNames("flex pt-4 px-4 md:pt-0 items-center border-t-2 border-gray-800 justify-evenly", {
      "!mb-3": isWebView()
    })
  }, /*#__PURE__*/React.createElement(Button, {
    type: "button",
    onClick: onMainUploadScreen,
    className: classNames("flex select-none grow mx-2 w-full", {
      "is-hidden": isUploadComplete
    })
  }, /*#__PURE__*/React.createElement("span", null, t("Cancel"))), /*#__PURE__*/React.createElement(Button, {
    onClick: onAfterCropping,
    className: "flex select-none grow mx-2 w-full",
    isPrimary: true
  }, /*#__PURE__*/React.createElement("span", null, t("Crop"))))) : /*#__PURE__*/React.createElement("div", {
    className: "pb-4 h-full flex w-full flex-col mx-auto min-h-96 overflow-hidden"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex-1 px-6 flex flex-col justify-center overflow-hidden"
  }, /*#__PURE__*/React.createElement("div", {
    className: "relative min-h-64 overflow-y-auto scrollbar-light dark:scrollbar rounded-lg"
  }, /*#__PURE__*/React.createElement("img", {
    src: croppedImageUrl,
    alt: "croppedImage",
    className: "mx-auto"
  })), /*#__PURE__*/React.createElement("p", {
    className: "text-gray-100 px-2 pb-2 text-base text-center py-2"
  }, "*", t("Cropped Image"))), /*#__PURE__*/React.createElement("div", {
    className: classNames("flex pt-4 md:pt-0 px-4 items-center justify-evenly border-t border-gray-800", {
      "!mb-3": isWebView()
    })
  }, /*#__PURE__*/React.createElement(Button, {
    type: "button",
    onClick: function onClick() {
      setCroppedImageUrl("");
    },
    className: classNames("select-none grow mx-2 w-full", {
      "is-hidden": isUploadComplete
    })
  }, /*#__PURE__*/React.createElement("span", null, t("Back"))), /*#__PURE__*/React.createElement(Button, {
    className: "select-none grow mx-2 w-full",
    onClick: onFinishCropping,
    isPrimary: true
  }, /*#__PURE__*/React.createElement("span", null, t("Upload Scan"))))));
};
export default CropImage;